'use client'

import {WhiteWhatsAppIcon } from '@/helper/SVG'
import {
  
  CURRENT_SUBSIDIARY,
  CONSUMER_WEB_PLATFORM,
  SUBSIDIARY_CONFIG
} from '@/utils/constants'
import { eventConstants, trackEvent } from '@/utils/events'
import { useEffect, useState } from 'react'
import { loadState } from '@/utils/localStorage'
import { useSelector } from '@/lib/store'

const loggedInMobileNumber = loadState('ctxVal') || null
const ContactOnWhatsApp = ({ page = 'HOME', pageType = 'webpage' }: { page?: string; pageType?: 'webpage' | 'lead' }) => {
  const cityState = useSelector((state) => state.city)
  const { CUSTOMER_CARE_DISPLAY_NUMBER, WHATSAPP_URL_WEBPAGE, WHATSAPP_URL_LEAD } =
    SUBSIDIARY_CONFIG
  
  const WHATSAPP_URL = pageType === 'lead' ? WHATSAPP_URL_LEAD : WHATSAPP_URL_WEBPAGE

  const [visible, setVisible] = useState(page !== 'PDP')

  useEffect(() => {
    if (page !== 'PDP') return

    const sentinel = document.getElementById('need-help-sentinel')
    if (!sentinel) {
      setVisible(true)
      return
    }

    const observer = new IntersectionObserver(([entry]) =>
      setVisible(!entry.isIntersecting)
    )
    observer.observe(sentinel)
    return () => observer.disconnect()
  }, [page])

  const eventPayload = {
    u_mb: loggedInMobileNumber || '',
    city: cityState?.currentCityObj?.name || null,
    app: CONSUMER_WEB_PLATFORM,
    subsidiary: CURRENT_SUBSIDIARY,
    source: page,
  }

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    trackEvent(eventConstants.BOOK_VIA_WHATSAPP, eventPayload)

    setTimeout(() => {
      window.open(WHATSAPP_URL, '_blank')
    }, 300)
  }

  if (!visible) return null

  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      onClick={handleClick}
      className={`bg-success-100 w-fit rounded-full flex items-center fixed right-6 z-10 contact_whatsApp_wrapper ${
        page === 'PDP' ? 'bottom-40' : 'bottom-20'
      }`}
    >
      <div className="bg-success-500 w-14 h-14 rounded-full flex items-center justify-center">
        <WhiteWhatsAppIcon />
      </div>
      <div className="py-[0.375rem] contact_whatsApp_content">
        <p className="text-label-md text-success-600">WhatsApp to book test</p>
        <p className="text-label-md">{CUSTOMER_CARE_DISPLAY_NUMBER}</p>
      </div>
    </a>
  )
}

export default ContactOnWhatsApp
